import { useEffect } from 'react';
import useGenerateInventoryRequest from '~/hooks/useGenerateInventoryRequest';

function scrollToTop() {
  requestAnimationFrame(() =>
    window.scrollTo({
      top: document.documentElement.offsetTop,
      behavior: 'smooth'
    })
  );
}

export default function useScrollToTop() {
  const inventoryRequest = useGenerateInventoryRequest(0);

  useEffect(() => {
    scrollToTop();
  }, [inventoryRequest]);
}
